import React, { useState, useEffect, useRef, useCallback, Suspense } from "react";
import { useParams, useNavigate } from 'react-router-dom';
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";

import NavigationBar from "../components/Nav";
import ApiService, { DistributorApiService } from "../api/ApiService";
import Loader from "../components/Loader";
import ApiSendEmail from "../api/ApiSendEmail";
import { ToastContainer, toast } from 'react-toastify';
import { ApiGetPrice } from "../components/ApiGetPrice";
import 'react-toastify/dist/ReactToastify.css';
import view1 from '../assets/Untitled.svg'
import { PricePanel } from "../components/PricePanel";
import { PDFDocument } from 'pdf-lib';

const Home = () => {
  const [VisualizerCategory, setCategories] = useState([]);
  const [data, setData] = useState([]);
  const [selectedRegion, setSelectedRegion] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);
  const [defaultImage, setDefaultImage] = useState(null);
  const [defaultAngle2Image, setDefaultAngle2Image] = useState(null);
  const [defaultGrain, setDefaultGrain] = useState(null);
  const [imagePathArray, setImagePathArray] = useState([]);
  const [imagesPathArray, setImagesPathArray] = useState([]);
  const [clickedData, setClickedData] = useState([]);
  const [defaultGrainType, setDefaultGrainType] = useState(null);
  const [nameData, setNameData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [result, setResult] = useState([]);
  const [finalArray, setFinalArray] = useState([]);
  const canvasRef = useRef(null);
  const resultImageRef = useRef(null);
  const resultImagePrint = useRef(null);
  const [hoveredCategoryId, setHoveredCategoryId] = useState(null);
  const [selectedChildCategory, setSelectedChildCategory] = useState(null);
  const [email, setEmail] = useState('');
  const [emailError, setEmailError] = useState('');
  const [name, setName] = useState('');
  const [nameError, setNameError] = useState('');
  const [comment, setComment] = useState("");
  const [hoveredRegion, setHoveredRegion] = useState(null);
  const [showEmailPopup, setShowEmailPopup] = useState(false);
  const [emailOnPrint, setEmailOnPrint] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const { id, distributorSlug } = useParams();
  // /distributor/<id> serves the same page from a different question: what is
  // this distributor allowed to show? Only the request changes — the response
  // has the same shape, so nothing downstream needs a special case.
  const isDistributor = Boolean(distributorSlug);
  // Which layout opens first is the backend's choice, not ours: asked with a
  // blank key it answers with the one that sorts first in admin (a
  // distributor's own list, or the global order for everyone else). So start
  // blank whenever the address carries no key and adopt what comes back.
  // This used to name a layout outright, which meant a bare /visualizer always
  // opened Galaxy Kitchen no matter how admin was ordered.
  const [layoutKey, setlayoutKey] = useState(id || '');
  // Distributor requests address a layout by its numeric id while the rest of
  // the app passes the key around. Responses carry both, so remember the
  // mapping as they arrive and a layout switch needs no extra round trip.
  const layoutIdByKeyRef = useRef({});
  // A distributor can have the cost snapshot switched off in admin. Only a
  // distributor can hide it — the ordinary visualizer always shows it — so
  // this starts true and is only ever turned off by what the API says.
  // Which side bar this visualizer shows: 'price', 'distributor' or 'none'.
  // Only a distributor can change it — the ordinary visualizer is always the
  // price panel — so it starts there and is only ever moved by the API.
  const [panelMode, setPanelMode] = useState('price');
  // Whether the © Domain Cabinets credit sits on the render. It belongs to
  // the distributor pages only — /visualizer never carries it — so it starts
  // off and is only ever turned on by a distributor's own setting.
  const [showCredit, setShowCredit] = useState(false);
  // Only a visitor who arrived WITH a key gets the address kept in step with
  // the layout they switch to. Without one, nothing is written to the bar.
  const urlCarriesKey = useRef(Boolean(id)).current;
  const [layoutangle, setlayoutAngle] = useState('V1');
  const urlPath = window.location.pathname;
  const key = urlPath.split('/').pop();
  const [selectedAngle, setSelectedAngle] = useState('V1');
  const siteURL = 'https://www.domaincabinets.com/';
  const currentDate = new Date();
  const formattedDate = `${currentDate.getMonth() + 1}-${currentDate.getDate()}-${currentDate.getFullYear()}`;
  const [svgUrl, setsvgUrl] = useState('');
  const [svgUrlAngle2, setsvgUrlAngle2] = useState('');
  const [svgContent, setSvgContent] = useState('');
  const [imageUpdated, setImageUpdated] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [lastViewedAngle, setLastViewedAngle] = useState(null);
  const [lastWidth, setLastWidth] = useState(window.innerWidth);
  const [categoryNames, setCategoryNames] = useState([]);
  const clickedDataRef = useRef({});
  const [isPanelOpen, setIsPanelOpen] = useState(false);
  const [priceData, setPriceData] = useState(null);
  const [layoutApiLayoutCode, setLayoutApiLayoutCode] = useState('');
  const [isPriceLoading, setIsPriceLoading] = useState(false);
  const dataRef = useRef(null);
  const lastTallRef = useRef(null);
  const [collectionId, setCollectionId] = useState('');
  const [baseImage, setBaseImage] = useState("");
  // Nav decides this (it owns the per-angle asset data needed to read each
  // cabinet's grain); Home just relays it to PricePanel so both agree.
  const [hideGrain, setHideGrain] = useState(false);
  const navigate = useNavigate();
  const isFetchingDataRef = useRef(false);

  const angleSvgMap = {
    V1: "angleOne",
    V2: "angleTwo",
    V3: "angleThree",
    V4: "angleFour",
  };

  const prevAngleRef = useRef(selectedAngle);

  const checkMobile = () => {
    const isMobileNow = window.innerWidth <= 760;
    setIsMobile(isMobileNow);

    if (
      (lastWidth <= 760 && window.innerWidth > 760) ||
      (lastWidth > 760 && window.innerWidth <= 760)
    ) {
      refreshAfterResize();
    }

    setLastWidth(window.innerWidth);
  };

  const refreshAfterResize = () => {
    window.location.reload();
  };

  useEffect(() => {
    clickedDataRef.current = clickedData;
  }, [clickedData]);

  useEffect(() => {
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => {
      window.removeEventListener('resize', checkMobile);
    };
  }, [lastWidth]);

  const prevLayoutKeyRef = useRef();
  const fetchDataRef = useRef();

  useEffect(() => {
    if (prevLayoutKeyRef.current !== layoutKey && !isMobile) {
      fetchData();
      prevLayoutKeyRef.current = layoutKey;
      if (urlCarriesKey) navigate(`/visualizer/${layoutKey}`, { replace: true });
    }

    fetchDataRef.current = fetchData;
  }, [layoutKey]);

  const getCommonImageName = (clickedItems) => {
    if (!Array.isArray(clickedItems)) return null;

    const imageNames = clickedItems
      .map(i => i?.imageName?.toLowerCase())
      .filter(Boolean);

    const counts = {};
    imageNames.forEach(name => {
      counts[name] = (counts[name] || 0) + 1;
    });

    const common = Object.entries(counts).find(([_, count]) => count >= 3);
    return common ? common[0] : null;
  };

  // Only remembers which view we came from. It used to also call a
  // syncFourthCategory() on the way back from V3, which took whichever colour
  // 3+ cabinet categories shared and overwrote the one category that differed
  // with it — so Apply-All followed by a single changed category (say Wall)
  // lost that change the moment you returned from view 3. It raced the
  // fetchData() that the same click fires, which is why the menu and the
  // render could disagree and why it did not happen every time.
  //
  // What it was patching is handled at the source now: Apply-All records the
  // colour for every cabinet category, including ones this layout has no
  // asset for (see unmatchedCabinets in Nav.jsx), so no category is left
  // behind for this to catch up afterwards.
  useEffect(() => {
    if (prevAngleRef.current !== selectedAngle) {
      prevAngleRef.current = selectedAngle;
    }
  }, [selectedAngle]);


 const fetchPrice = async (currentFinalArray, currentLayoutKey, apiLayoutCode) => {
    if (!currentFinalArray || currentFinalArray.length === 0) return;

    const getItem = (parentName) =>
      currentFinalArray.find(i => i.parentName === parentName);

    const base = getItem('Base Cabinets');
    const wall = getItem('Wall Cabinets');
    const tall = getItem('Tall Cabinets');
    const island = getItem('Island Cabinets');
    const vanity = getItem('Vanity Cabinets');
    const grain = getItem('Style & Grain');
    const appliance = getItem('Appliances');

    // Kitchen layouts need base+wall+island; bathroom/vanity layouts need
    // just vanity — either one is enough to price the layout.
    const hasKitchenSet = base && wall && island;
    if (!hasKitchenSet && !vanity) return;

    if (tall) {
      lastTallRef.current = tall;
    }
    const effectiveTall = tall || lastTallRef.current;

    const grainDirectionMap = {
      1: 2,
      2: 1,
      3: 6,
      4: 5,
    };

    const getCollectionId = (item) => {
      if (!dataRef.current?.Collections) return null;

      const clickedItem = clickedDataRef.current?.[layoutKey]?.find(
        c => c.parentName === item.parentName
      );

      const categoryNameToMatch = clickedItem?.categoryName || item.categoryName;

      const matched = dataRef.current.Collections.find(
        c => c.name?.trim().toLowerCase() === categoryNameToMatch?.trim().toLowerCase()
      );

      return matched?.api_collection_id ?? null;
    };

    const getGrainId = (parentName, assetId, grainId) => {
      if (!VisualizerCategory?.GroupAssets) return grainId;
      const group = VisualizerCategory.GroupAssets.find(
        g => g.name?.trim().toLowerCase() === parentName?.trim().toLowerCase()
      );
      if (!group) return grainId;
      const asset = group.GroupAssetsColor?.find(a => a.id === assetId);
      if (!asset) return grainId;

      const collection = dataRef.current?.Collections?.find(
        c => c.id === (asset?.collection_id || asset?.AssetCollection?.id)
      );
      if (!collection) return grainId;

      const color = collection.CollectionColor?.find(cc => cc.id === assetId);
      if (!color) return grainId;

      const allowedGrainIds = color.api_grain_direction_ids?.split(',').map(Number) || [];
      const mappedGrainId = grainDirectionMap[grainId];

      if (allowedGrainIds.includes(mappedGrainId)) return mappedGrainId;
      return allowedGrainIds[0] || grainId;
    };

    const grainId = grain?.id || 1;

    const params = {
      ...(hasKitchenSet ? {
        base: {
          collection_id: getCollectionId(base),
          color_id: base.color_id,
          doorstyleandgrain_id: getGrainId('Base Cabinets', base.id, grainId),
        },
        wall: {
          collection_id: getCollectionId(wall),
          color_id: wall.color_id,
          doorstyleandgrain_id: getGrainId('Wall Cabinets', wall.id, grainId),
        },
        island: {
          collection_id: getCollectionId(island),
          color_id: island.color_id,
          doorstyleandgrain_id: getGrainId('Island Cabinets', island.id, grainId),
        },
      } : {}),
      ...(vanity ? {
        vanity: {
          collection_id: getCollectionId(vanity),
          color_id: vanity.color_id,
          doorstyleandgrain_id: getGrainId('Vanity Cabinets', vanity.id, grainId),
        }
      } : {}),
      ...(effectiveTall ? {
        tall: {
          collection_id: getCollectionId(effectiveTall),
          color_id: effectiveTall.color_id,
          doorstyleandgrain_id: getGrainId('Tall Cabinets', effectiveTall.id, grainId),
        }
      } : {}),
      ...(appliance
        ? {
          appliance: {
            name: appliance.imageName,
            id: appliance.id,
          },
        }
        : {}),
    };

    const finalLayoutCode = apiLayoutCode ?? layoutApiLayoutCode;

    try {
      setIsPriceLoading(true);
      const result = await ApiGetPrice(currentLayoutKey, params, finalLayoutCode);
      setPriceData(result);
    } catch (err) {
      console.error('Price fetch error:', err);
    } finally {
      setIsPriceLoading(false);
    }
  };

  const fetchData = async (angle) => {
    isFetchingDataRef.current = true;
    const selectedAngleValue = angle || layoutangle;

    try {
      setIsLoading(true);
      setImageUpdated(false);

      const response = isDistributor
        ? await DistributorApiService(
          distributorSlug,
          // Blank on the very first call: the backend then answers with this
          // distributor's first layout, which is how the page bootstraps
          // without knowing any layout id yet.
          layoutIdByKeyRef.current[layoutKey] ?? '',
          selectedAngleValue
        )
        : await ApiService("visualizer/layoutcolorassets", layoutKey, selectedAngleValue);

      if (response.Result === 1) {
        const data = response.Result_value;
        const Layout = data.Layout;

        // In distributor mode we asked with a blank layout and the backend
        // chose one, so everything below keys off what actually came back.
        const activeLayoutKey = Layout?.key || layoutKey;

        // Defaults arrive either as a JSON string or already parsed.
        const parseDefaults = (raw) => {
          if (!raw) return null;
          if (Array.isArray(raw)) return raw;
          try {
            const parsed = JSON.parse(raw);
            return Array.isArray(parsed) ? parsed : null;
          } catch {
            return null;
          }
        };

        if (isDistributor) {
          // Keep the key → numeric id mapping fresh for the next switch.
          (data.Layouts || []).forEach((l) => {
            if (l?.key) layoutIdByKeyRef.current[l.key] = l.id;
          });

          // This endpoint answers Angles as a plain list of allowed view keys
          // (['V1']), while the app expects the angle CONFIG keyed by view.
          // Rebuild that config from the layout, keeping only allowed views, so
          // the view switcher works unchanged and offers nothing extra.
          const allowedKeys = Array.isArray(data.Angles) ? data.Angles : null;
          const allAngles = JSON.parse(Layout.configuration || '{}').angles || {};
          data.Angles = {
            angles: allowedKeys
              ? Object.fromEntries(
                Object.entries(allAngles).filter(([key]) => allowedKeys.includes(key))
              )
              : allAngles,
          };

          // The distributor row comes back as-is: `settings` is a JSON string
          // ({ collection, layout, price, default }) and `default_settings` its
          // own column, also a JSON string.
          let distributorSettings = {};
          try {
            const raw = data.Distributor?.settings;
            distributorSettings = (typeof raw === 'string' ? JSON.parse(raw || '{}') : raw) || {};
          } catch {
            distributorSettings = {};
          }

          // The distributor's own side-bar choice. Rows saved before the
          // dropdown existed hold a boolean here, where false meant "hide it";
          // that reads as 'none' and everything else as the price panel, so an
          // older row keeps behaving exactly as it did.
          const savedPanel = distributorSettings.price;
          setPanelMode(
            savedPanel === false || savedPanel === 'none'
              ? 'none'
              : savedPanel === 'distributor'
                ? 'distributor'
                : 'price'
          );

          // Same reading as the admin screen: rows saved before the checkbox
          // existed carry no `credit` key and were all showing it, so only an
          // explicit false hides it.
          setShowCredit(distributorSettings.credit !== false);

          // The distributor's own defaults (set in admin) replace the layout's.
          // Written back onto Layout.default_settings because that is where
          // everything downstream — here and in Nav (style, grain, appliance) —
          // reads defaults from. Older rows kept them inside settings.default.
          const distributorDefaults =
            parseDefaults(data.Distributor?.default_settings) ||
            parseDefaults(distributorSettings.default);
          if (distributorDefaults?.length) {
            Layout.default_settings = JSON.stringify(
              // Style ids are numbers in the layout's defaults and Nav matches
              // them with ===; admin saves them as strings.
              distributorDefaults.map((ds) =>
                ds.Style != null && ds.Style !== '' ? { ...ds, Style: Number(ds.Style) } : ds
              )
            );
          }

        }

        // We asked with a blank key and the backend picked the layout — adopt
        // its key so every layout-keyed piece of state lines up. Recording it
        // as already-fetched keeps the effect below from firing a second,
        // identical request. A visitor who arrived with a key gets the layout
        // they asked for, so this is a no-op for them.
        if (Layout?.key && Layout.key !== layoutKey) {
          prevLayoutKeyRef.current = Layout.key;
          setlayoutKey(Layout.key);
        }
        const config = JSON.parse(Layout.configuration);
        // A distributor's collections can leave out the colour this layout
        // defaults to — one with only EGGER against a layout that defaults to a
        // Shinnoki colour — and every cabinet then opened as N/A with no price
        // at all. Fall back to the first texture on offer.
        //
        // "First" is the sort_order set in admin, oldest first where that is
        // unset, ties broken on the id. The tie-break is what makes this usable:
        // most colours share sort_order 0 and the API does not return rows in a
        // stable order, so without it three identical loads picked three
        // different woods.
        const firstTextureOrder = (asset) =>
          asset.AssetColor?.sort_order ?? new Date(asset.created_at).getTime();

        const byFirstTexture = (a, b) =>
          firstTextureOrder(a) - firstTextureOrder(b) ||
          Number(a.color_id) - Number(b.color_id);

        // The choice is made ONCE per default entry, from the first category in
        // it that has anything. The four cabinet groups share a single default,
        // and resolving per category gave each of them a different wood.
        const resolveMissingDefaults = (settings, groups) =>
          settings.map((ds) => {
            if (!ds.colro_id) return ds;

            const groupIds = (ds.group_id || '').split(',');
            const inScope = groups.filter((g) => groupIds.includes(String(g.id)));

            // The default is already on the menu — nothing to do.
            if (
              inScope.some((g) =>
                (g.GroupAssetsColor || []).some(
                  (a) => String(a.color_id) === String(ds.colro_id)
                )
              )
            ) {
              return ds;
            }

            const firstStocked = inScope.find((g) => (g.GroupAssetsColor || []).length);
            if (!firstStocked) return ds;

            const replacement = [...firstStocked.GroupAssetsColor].sort(byFirstTexture)[0];

            return { ...ds, colro_id: String(replacement.color_id) };
          });

        // In distributor mode Layout.default_settings already holds the
        // distributor's own defaults (swapped in above).
        const defaultSettings = resolveMissingDefaults(
          JSON.parse(Layout.default_settings || '[]'),
          data.GroupAssets || []
        );
        const grainObj = defaultSettings.find(item => item.grain);
        const defaultGrain = grainObj ? grainObj.grain : null;
        const color_id = defaultSettings.find(item => item.colro_id);
        const defaultColor = color_id ? color_id.color_id : null;
        if (config.angles && config.angles.V1) {
          const rawBaseImage = config.angles.V1.image;
          const imageBaseUrl = process.env.REACT_APP_VISUAL_APP_IMAGE_BASE_URL || "";
          setBaseImage(
            rawBaseImage?.startsWith('http') ? rawBaseImage : `${imageBaseUrl}${rawBaseImage}`
          );
        }

        const currentApiLayoutCode = Layout.api_layout_code;
        setDefaultGrain(defaultGrain);
        setLayoutApiLayoutCode(currentApiLayoutCode);
        setNameData(Layout.name);
        document.title = Layout.name;

        const anglesConfig = config?.angles || {};
        const currentAngleConfig = anglesConfig[selectedAngleValue] || {};

        const defaultImage = currentAngleConfig.image || "";
        setDefaultImage(defaultImage);

        const baseUrl = process.env.REACT_APP_VISUAL_APP_IMAGE_BASE_URL || "";

        const svgUrl = currentAngleConfig?.svg
          ? `${baseUrl}${currentAngleConfig.svg}`
          : "";

        setsvgUrl(svgUrl);

        if (svgUrl) {
          try {
            const responsesvg = await fetch(svgUrl);
            // S3 returns 200-shaped XML error bodies (e.g. NoSuchKey) on missing
            // assets — fetch() doesn't reject on those, so check .ok before
            // injecting the response as SVG markup.
            if (!responsesvg.ok) {
              console.error("SVG not found:", svgUrl, responsesvg.status);
              setSvgContent("");
            } else {
              const svgText = await responsesvg.text();
              setSvgContent(svgText);
            }
          } catch (error) {
            console.error("Error fetching SVG:", error);
            setSvgContent("");
          }
        }

        const allResults = [];
        const defaultGrainTypeResult = {
          parentName: "Style & Grain",
          categoryName: "Slab",
          id: 2,
          imageName: defaultGrain,
        };
        allResults.push(defaultGrainTypeResult);

        // Selections are shared across layouts. The first time a layout is
        // opened it has no clickedData entry of its own, and the effect that
        // copies one over from an already-configured layout only runs AFTER this
        // fetch has finished — so the first switch composited from defaults and
        // the user's change appeared only on the second visit to that layout.
        // Inherit here, before the images are chosen, so it lands immediately.
        const rawClickedData = clickedDataRef.current;
        const inheritedForLayout =
          rawClickedData?.[activeLayoutKey]?.length
            ? null
            : Object.values(rawClickedData ?? {}).find(
                (entries) => Array.isArray(entries) && entries.length > 0
              );

        const currentClickedData = inheritedForLayout
          ? { ...rawClickedData, [activeLayoutKey]: [...inheritedForLayout] }
          : rawClickedData;

        let extractedDefaultGrain = defaultGrain;

        const cleanedData = Object.fromEntries(
          Object.entries(currentClickedData ?? {}).map(([key, items]) => {
            items = items ?? [];

            let filtered = items
              .filter(item => item?.id !== undefined)
              .map(item => ({
                ...item,
                categoryName:
                  item.parentName === "Appliances"
                    ? "Appliances"
                    : item.categoryName
              }));

            const styleItems = filtered.filter(i => i.parentName === "Style & Grain");

            if (styleItems.length > 0) {
              const last = styleItems[styleItems.length - 1];
              extractedDefaultGrain = last.imageName;

              filtered = filtered.filter(i => i.parentName !== "Style & Grain");

              filtered.push({
                ...last,
                grain: last.imageName
              });
            }

            return [key, filtered];
          })
        );
        const getApiColorId = async (colorId) => {
          const collectionsData = data?.Collections || [];
          if (!colorId || collectionsData.length === 0) return null;

          let matchedColor = null;
          let matchedCollection = null;

          for (const collection of collectionsData) {
            const found = collection.CollectionColor?.find(
              (cc) => cc.id?.toString() === colorId?.toString()
            );
            if (found) {
              matchedColor = found;
              matchedCollection = collection;
              break;
            }
          }

          if (!matchedColor) return null;

          const colorCode = matchedColor.color_code;
          const collectionId = matchedCollection.api_collection_id;
          setCollectionId(collectionId);

          try {
            const response = await fetch(
              `https://customcabinetry-middleware.herokuapp.com/api/getcolorandgrain`,
              {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ collection_id: collectionId }),
              }
            );
            const apiData = await response.json();

            const colors = apiData?.data?.colors || apiData?.colors || apiData?.Colors || [];
            const apiMatched = Array.isArray(colors)
              ? colors.find((c) => c.color_code?.toString() === colorCode?.toString())
              : null;

            return apiMatched?.id ?? null;

          } catch (err) {
            console.error('Error fetching color and grain API:', err);
            return null;
          }
        };

        const collectedCategoryNames = [];

        const initialPaths = (
          await Promise.all(
            (data?.GroupAssets || []).map(async (category) => {
              const groupAssets = Array.isArray(category.GroupAssetsColor)
                ? category.GroupAssetsColor
                : [];
              collectedCategoryNames.push(category.name);
              let colorMatchedAssets = [];

              if (category.name === "Appliances") {
                colorMatchedAssets = groupAssets.filter(asset =>
                  defaultSettings.some(ds => ds.appliances && ds.appliances === asset.name)
                );
              } else {
                colorMatchedAssets = groupAssets.filter(asset =>
                  defaultSettings.some(
                    ds =>
                      ds.colro_id?.toString() === asset.color_id?.toString() &&
                      ds.group_id?.split(",").includes(category.id.toString())
                  )
                );
              }

              if (colorMatchedAssets.length === 0) return [];

              let matchedAsset = colorMatchedAssets.find(asset => asset.grain === extractedDefaultGrain);
              if (!matchedAsset) matchedAsset = colorMatchedAssets[0];

              const resolvedApiColorId = await getApiColorId(matchedAsset?.color_id);
              allResults.push({
                parentName: category.name,
                categoryName: matchedAsset?.AssetCollection?.name || '',
                id: matchedAsset.id,
                color_id: resolvedApiColorId,
                imageName: matchedAsset.name,
              });

              let imagePath =
                matchedAsset.grain === "NoGrain"
                  ? matchedAsset.asset_image?.image || matchedAsset.asset_image
                  : matchedAsset.asset_image;

              if (cleanedData && Array.isArray(cleanedData[activeLayoutKey])) {
                const clickedItem = cleanedData[activeLayoutKey].find(item =>
                  item.parentName?.trim().toLowerCase() === category.name?.trim().toLowerCase()
                );
                setDefaultGrain(extractedDefaultGrain);

                if (clickedItem) {
                  let matchedCollection = null;
                  let finalMatchedColor = null;

                  const clickedCategory = clickedItem.categoryName?.trim().toLowerCase();
                  const clickedImageName = clickedItem.imageName?.trim().toLowerCase();

                  if (clickedCategory === "appliances") {
                    const applianceMatch = groupAssets.find(color =>
                      color.name?.trim().toLowerCase() === clickedImageName
                    );
                    if (applianceMatch) {
                      finalMatchedColor = applianceMatch;
                    }
                  } else {
                    const hasNoCollection = groupAssets.some(a => !a.AssetCollection || a.collection_id === 0);

                    if (hasNoCollection) {
                      const directMatch = groupAssets.find(color => {
                        const colorNameLower = color.name?.trim().toLowerCase();
                        if (colorNameLower !== clickedImageName) return false;
                        if (color.grain !== "NoGrain") {
                          return color.grain === extractedDefaultGrain;
                        }
                        return true;
                      });

                      if (directMatch) {
                        finalMatchedColor = directMatch;
                      }
                    } else {
                      matchedCollection = groupAssets.find(color => {
                        const collectionName = color.AssetCollection?.name?.trim().toLowerCase();
                        if (!collectionName) return false;
                        return (
                          collectionName === clickedCategory ||
                          collectionName + "s" === clickedCategory ||
                          collectionName === clickedCategory + "s"
                        );
                      });

                      if (matchedCollection) {
                        const colorByImageName = groupAssets.find(color => {
                          const colorNameLower = color.name?.trim().toLowerCase();
                          if (colorNameLower !== clickedImageName) return false;
                          if (color.grain !== "NoGrain") {
                            return color.grain === extractedDefaultGrain;
                          }
                          return true;
                        });

                        finalMatchedColor = colorByImageName || matchedCollection;
                      }
                    }
                  }

                  if (finalMatchedColor) {
                    const resolvedFinalApiColorId = await getApiColorId(finalMatchedColor?.color_id);

                    const existingIndex = allResults.findIndex(
                      r => r.parentName === category.name
                    );
                    if (existingIndex !== -1) {
                      allResults[existingIndex] = {
                        ...allResults[existingIndex],
                        color_id: resolvedFinalApiColorId,
                      };
                    }

                    imagePath =
                      finalMatchedColor.grain === "NoGrain"
                        ? finalMatchedColor.asset_image?.image || finalMatchedColor.asset_image
                        : finalMatchedColor.asset_image;
                  }
                }
              }

              return [{ path: imagePath, category: category.name }];
            })
          )
        ).flat();

        setCategoryNames([...new Set(collectedCategoryNames)]);

        if (defaultImage) {
          initialPaths.push({ path: defaultImage, category: "Baseing" });
        }

        setImagePathArray(initialPaths);
        setData(data);
        dataRef.current = data;
        setCategories(data);

        // Same inherited set the images above were built from, so finalArray and
        // the price agree with what is drawn on the very first switch.
        const items = currentClickedData?.[activeLayoutKey];

        if (Array.isArray(items) && items.length > 0) {
          const updatedResult = allResults.map((resultItem) => {
            const clickedItem = items.find(
              (clicked) =>
                clicked?.parentName === resultItem?.parentName &&
                clicked?.categoryName === resultItem?.categoryName
            );

            return clickedItem
              ? {
                ...resultItem,
                // A selection carried over from a layout that owns this category
                // has id/color_id null (it had no asset of its own to point at),
                // so fall back to the asset this layout just resolved by name —
                // otherwise the null would wipe a valid id out of the price payload.
                id: clickedItem.id ?? resultItem?.id,
                imageName: clickedItem.imageName,
                color_id: clickedItem?.color_id ?? resultItem?.color_id,
              }
              : resultItem;
          });

          setFinalArray(updatedResult);

          isFetchingDataRef.current = true;
          await fetchPrice(updatedResult, activeLayoutKey, currentApiLayoutCode);
          isFetchingDataRef.current = false;

        } else {
          setFinalArray(allResults);

          isFetchingDataRef.current = true;
          await fetchPrice(allResults, activeLayoutKey, currentApiLayoutCode);
          isFetchingDataRef.current = false;
        }
      }
    } catch (err) {
      console.error("Error fetching data:", err);
      setIsLoading(false);
      isFetchingDataRef.current = false;
    }
  };

  const handleImageClick = useCallback(async (imagePath, parentName, angleview, grain) => {
    const currentLayoutKey = layoutKey;

    // imagePathArray must update in the same batch as the caller's clickedData
    // update (Nav.jsx), before any await below — otherwise the imagePathArray
    // change lands on a later tick, the loading effect fires twice (once on
    // stale data, once for real), and the loader flashes off then back on.
    setImagePathArray(prevArray => {
      return prevArray.map(item => {
        const matchingImage = imagePath.find(img => img.category === item.category);
        if (matchingImage) {
          if (item.category === "Baseing") {
            return { ...item, path: angleview === 'V2' ? defaultAngle2Image : defaultImage };
          }
          return { ...item, path: matchingImage.path };
        }
        return item;
      });
    });

    setSelectedImage({
      imageName: imagePath[0]?.name,
      parentName,
      categoryName: imagePath[0]?.category,
      categoryId: imagePath[0]?.id
    });

    const svgToLoad = angleview === 'V2' ? svgUrlAngle2 : svgUrl;
    if (svgToLoad) {
      try {
        const response = await fetch(svgToLoad);
        if (!response.ok) {
          console.error("SVG not found:", svgToLoad, response.status);
          setSvgContent("");
        } else {
          const svgText = await response.text();
          setSvgContent(svgText);
        }
      } catch (err) {
        console.error("Error fetching SVG:", err);
      }
    }
  }, [svgUrl, svgUrlAngle2, defaultImage, defaultAngle2Image, layoutKey]);


  useEffect(() => {
    if (!finalArray?.length || !VisualizerCategory?.GroupAssets?.length) return;
    if (isFetchingDataRef.current) return;

    // Same test fetchPrice itself makes: a kitchen prices off base+wall+island,
    // a bathroom off its vanity. This used to demand the kitchen trio outright,
    // and a bathroom has none of those — so changing a texture there never
    // reached fetchPrice and the panel kept whatever the load-time call in
    // fetchData had put there.
    const hasKitchenSet = ['Base Cabinets', 'Wall Cabinets', 'Island Cabinets'].every(
      (p) => finalArray.some((f) => f.parentName === p && f.id)
    );
    const hasVanity = finalArray.some((f) => f.parentName === 'Vanity Cabinets' && f.id);
    if (!hasKitchenSet && !hasVanity) return;

    fetchPrice(finalArray, layoutKey);
  }, [finalArray, layoutKey]);

  useEffect(() => {
    let currentClicked = clickedData?.[layoutKey];

    if ((!currentClicked || currentClicked.length === 0) && clickedData) {
      const otherLayoutData = Object.values(clickedData).find(
        (items) => Array.isArray(items) && items.length > 0
      );

      if (otherLayoutData) {
        setClickedData(prev => ({
          ...(prev || {}),
          [layoutKey]: [...otherLayoutData]
        }));
        currentClicked = otherLayoutData;
      }
    }

    if (Array.isArray(currentClicked) && currentClicked.length > 0) {
      const updatedResult = (finalArray || []).map((resultItem) => {
        const clickedItem = currentClicked.find(
          (clicked) => clicked?.parentName === resultItem?.parentName
        );

        if (clickedItem) {
          return {
            ...resultItem,
            categoryName: clickedItem?.categoryName ?? resultItem?.categoryName,
            id: clickedItem?.id ?? resultItem?.id,
            imageName: clickedItem?.imageName ?? resultItem?.imageName,
            color_id: clickedItem?.color_id ?? resultItem?.color_id,
          };
        }

        return resultItem;
      });

      setFinalArray(updatedResult);
    }

    if (typeof handleImageLoad === "function") {
      handleImageLoad();
    }

    // layoutKey is intentionally NOT in this dependency list. layoutKey changes
    // the instant a style/layout is clicked, well before fetchData() (a separate
    // effect) has actually fetched the new layout's data — if layoutKey were
    // here, this effect fires immediately on the OLD, already-cached
    // imagePathArray, composites it fast, and turns the loader off before the
    // real fetch even starts. It then fires again for real once imagePathArray
    // itself updates with the new layout's data — that premature on/off/on
    // cycle is what caused the loader-flash and blank-screen gap. imagePathArray
    // updating is itself sufficient to re-run this effect with the current
    // layoutKey (read via closure), so nothing is lost by omitting it here.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [imagePathArray, clickedData]);

  const imageCache = useRef({});
  // Bump this whenever the S3 layout assets are replaced. Appending it to the
  // request URL gives the browser a fresh cache key, so it can never reuse a
  // pre-CORS cached copy of an image (one fetched by a plain <img> before the
  // bucket's CORS policy existed) — that stale copy has no
  // Access-Control-Allow-Origin header and is what triggers the canvas/CORS error.
  const ASSET_CACHE_VERSION = 'v1';
  const withCacheBust = (url) =>
    `${url}${url.includes('?') ? '&' : '?'}cb=${ASSET_CACHE_VERSION}`;

  const loadImage = (path) => {
    if (!path) return Promise.resolve(null);

    if (imageCache.current[path]) return Promise.resolve(imageCache.current[path]);

    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => {
        imageCache.current[path] = img;
        resolve(img);
      };
      img.onerror = (err) => {
        console.error("Error loading image:", path, err);
        resolve(null);
      };
      const fullPath = path.startsWith('http')
        ? path
        : `${process.env.REACT_APP_VISUAL_APP_IMAGE_BASE_URL}${path}`;
      // crossOrigin MUST be set before src, or some browsers skip the CORS
      // request entirely and the canvas becomes tainted.
      img.crossOrigin = 'anonymous';
      img.src = withCacheBust(fullPath);
    });
  };

  const arrangeImages = (baseImages, overlayImages, ctx, runId) => {
    // Cabinets-type layers (Base/Wall/Island/Tall for one layout, Tall/Vanity
    // for another) must always draw before non-cabinet layers (Backsplash/
    // Countertop/Flooring), regardless of the order the API returns them in.
    const cabinetCategoryNames = new Set(
      (VisualizerCategory?.GroupAssets || [])
        .filter(g => g.category === 'Cabinets')
        .map(g => g.name?.trim().toLowerCase())
    );
    const isCabinetLayer = (item) =>
      cabinetCategoryNames.has(item.category?.trim().toLowerCase());

    const applianceIndex = overlayImages.findIndex((item) => item.category === 'Appliances');
    const applianceItem = applianceIndex > -1 ? overlayImages.splice(applianceIndex, 1)[0] : null;

    const cabinets = [];
    const others = [];
    overlayImages.forEach(item => (isCabinetLayer(item) ? cabinets : others).push(item));
    overlayImages = [...cabinets, ...others];

    if (applianceItem) {
      overlayImages.splice(cabinets.length, 0, applianceItem);
    }

    let maxWidth = 0;
    let maxHeight = 0;

    const allImages = [...baseImages, ...overlayImages.map(({ img }) => img)];
    allImages.forEach((img) => {
      maxWidth = Math.max(maxWidth, img.width);
      maxHeight = Math.max(maxHeight, img.height);
    });

    // If every image failed to load (e.g. this layout's assets are missing on
    // S3), maxWidth/maxHeight stay 0. canvas.toDataURL() on a 0x0 canvas
    // returns the invalid string "data:," — assigning that as <img src> is
    // exactly what renders the browser's broken-image icon. Skip assigning a
    // src at all in that case, and report failure so the caller knows not to
    // reveal the <img> (its declarative src={baseImage} can 404 too).
    if (allImages.length === 0 || maxWidth === 0 || maxHeight === 0) {
      return false;
    }

    // Size, draw and read back the SAME canvas that ctx belongs to — never
    // canvasRef.current. handleImageLoad() swaps canvasRef.current for a fresh
    // canvas on every run, and runs overlap (a layout switch changes both
    // imagePathArray and clickedData, firing the compositing effect twice). When
    // they did, the older run resized and exported the NEWER run's canvas while
    // drawing into its own — and resizing a canvas clears it, so toDataURL()
    // returned a correctly sized but fully transparent PNG. That is the blank
    // white viewer seen when switching layouts without a page refresh: no error,
    // no broken image, just an empty composite.

    // A newer run has already superseded this one — drop it rather than overwrite
    // the fresher composite with stale layers.
    if (runId !== composeRunRef.current) return false;

    const target = ctx.canvas;
    target.width = maxWidth;
    target.height = maxHeight;

    baseImages.forEach((img) => ctx.drawImage(img, 0, 0, maxWidth, maxHeight));
    overlayImages.forEach(({ img }) => ctx.drawImage(img, 0, 0, maxWidth, maxHeight));

    const dataUrl = target.toDataURL();
    resultImageRef.current.src = dataUrl;
    resultImagePrint.current.src = dataUrl;
    return true;
  };

  // Overlapping compositing runs are normal (a layout switch changes both
  // imagePathArray and clickedData). Each run takes a ticket; only the newest one
  // is allowed to publish, so a slow earlier run can't finish last and leave the
  // previous layout's image on screen.
  const composeRunRef = useRef(0);

  const handleImageLoad = async () => {
    const runId = ++composeRunRef.current;
    let canvas = canvasRef.current;
    if (!canvas) return;
    const freshCanvas = document.createElement('canvas');
    freshCanvas.width = canvas.width;
    freshCanvas.height = canvas.height;
    canvasRef.current = freshCanvas;
    canvas = freshCanvas;

    const ctx = canvas.getContext('2d');
    const baseImages = [];
    const overlayImages = [];

    const flatImageArray = imagePathArray.flat();
    if (!flatImageArray.length) return;
    setIsLoading(true);

    try {
      const loadedImages = await Promise.all(
        flatImageArray.map(({ path, category }) => loadImage(path))
      );

      loadedImages.forEach((img, index) => {
        if (!img) return;
        const { category } = flatImageArray[index];
        if (category === 'Baseing') baseImages.push(img);
        else overlayImages.push({ img, category });
      });

      const composited = arrangeImages(baseImages, overlayImages, ctx, runId);

      requestAnimationFrame(() => {
        // Only reveal the <img> when compositing actually produced a valid
        // image — otherwise its declarative src={baseImage} can itself point
        // to a missing asset and show the browser's broken-image icon.
        if (composited) {
          setImageUpdated(true);
        }
        setIsLoading(false);
      });

    } catch (err) {
      console.error("Error loading images:", err);
      setIsLoading(false);
    }
  };

  const handleRegionHover = (regionId) => {
    const svg = document.getElementById(`${angleSvgMap[selectedAngle]}`);
    const regions = svg?.querySelectorAll("g");
    regions.forEach((region) => {
      const allElements = region.querySelectorAll("g, path, polygon, rect");

      if (region.id.trim() === regionId.trim()) {
        region.style.opacity = 0.7;
        allElements.forEach(el => {
          el.style.opacity = 0.7;
          el.style.fillOpacity = 0.7;
        });
      } else {
        region.style.opacity = 0;
        allElements.forEach(el => {
          el.style.opacity = 0;
          el.style.fillOpacity = 0;
        });
      }
    });

    setSelectedRegion(prev => (prev === regionId ? null : regionId));
  };

  const handleRegionClick = (categoryId) => {
    setHoveredCategoryId((prevCategory) => {
      if (prevCategory === categoryId) return prevCategory;
      return categoryId;
    });
  };

  const handleRegionLeave = () => {
    const svg = document.getElementById(`${angleSvgMap[selectedAngle]}`);
    const regions = svg?.querySelectorAll("g");

    if (regions && regions.length) {
      regions.forEach((region) => {
        const regionPaths = region.querySelectorAll("path");
        region.style.opacity = 0;
        regionPaths.forEach((path) => {
          path.style.opacity = 0;
        });
      });
    }

    setSelectedRegion(null);
  };

  const handleEmailChange = (e) => {
    const emailValue = e.target.value;
    setEmail(emailValue);

    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailValue) {
      setEmailError('Email is required');
    } else if (!emailPattern.test(emailValue)) {
      setEmailError('Please enter a valid email address');
    } else {
      setEmailError('');
    }
  };

  const handleNameChange = (e) => {
    const nameValue = e.target.value;
    setName(nameValue);

    const namePattern = /^[A-Za-z\s]+$/;
    if (!nameValue) {
      setNameError('Name is required');
    } else if (!namePattern.test(nameValue)) {
      setNameError('Name should contain only letters and spaces');
    } else if (nameValue.length < 2 || nameValue.length > 50) {
      setNameError('Name should be between 2 and 50 characters');
    } else {
      setNameError('');
    }
  };

  const handleCommentChange = (e) => setComment(e.target.value);

  const generatePDF = async (arg) => {
    setShowEmailPopup(false);
    setEmailOnPrint(false);
    setIsLoading(true);

    if (!finalArray || finalArray.length === 0) {
      console.error("No data available to generate the PDF.");
      return;
    }

    const doc = new jsPDF({
      orientation: "portrait",
      unit: "mm",
      format: "letter"
    });

    const canvas = resultImageRef.current;

    if (canvas) {
      try {
        const canvasImage = await html2canvas(canvas, { useCORS: true, backgroundColor: null, scale: 1 });
        const imgData = canvasImage.toDataURL("image/jpeg", 0.6);

        if (!imgData) {
          console.error("Failed to capture canvas as image.");
          return;
        }

        const pageWidth = doc.internal.pageSize.width;
        const pageHeight = doc.internal.pageSize.height;

        doc.setFont("helvetica", "bold");
        doc.setFontSize(17);
        const headerTitle = "Your Custom Visualizer Selections" || "Default Title";
        const headerWidth = doc.getTextWidth(headerTitle);
        const headerX = (pageWidth - headerWidth) / 2;
        doc.text(headerTitle, headerX, 20);

        const imageWidth = pageWidth - 20;
        const imageHeight = (canvas.height / canvas.width) * imageWidth;
        const imageX = (pageWidth - imageWidth) / 2;
        doc.addImage(imgData, "JPEG", 10, 30, imageWidth, imageHeight);

        doc.setFont("helvetica", "normal");
        doc.setFontSize(12);

        let yPosition = 130;
        const column1X = 30;
        const column2X = 90;
        const lineHeight = 6;
        const line2Height = 6;
        const lineSpacing = 15;
        const lineSpacing2 = 4;
        yPosition += lineHeight + lineSpacing;

        finalArray.forEach(({ parentName, categoryName, imageName }, index) => {
          if (index === 0) {
            doc.text(parentName, column1X, yPosition);
            const detailsText = `${categoryName}, ${imageName || "N/A"}`;
            doc.text(detailsText, column2X, yPosition, { align: "left" });
          } else if (index >= finalArray.length - 3) {
            doc.text(parentName, column1X, yPosition);
            const detailsText = `${categoryName}: ${imageName || "N/A"}`;
            doc.text(detailsText, column2X, yPosition, { align: "left" });
          } else {
            doc.text(parentName, column1X, yPosition);

            if (parentName === "Appliance") {
              const detailsText = `${imageName || "N/A"}`;
              doc.text(detailsText, column2X, yPosition, { align: "left" });
            } else {
              const detailsText = `Door Collection: ${categoryName}`;
              doc.text(detailsText, column2X, yPosition, { align: "left" });

              const colorText = `Color: ${imageName || "N/A"}`;
              yPosition += line2Height;
              doc.text(colorText, column2X, yPosition, { align: "left" });
            }
          }

          yPosition += lineHeight + lineSpacing2;
        });

        const currentDate = new Date().toLocaleDateString("en-US", {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit'
        }).replace(/\//g, '-');

        doc.setFont("helvetica", "normal");
        doc.setFontSize(10);

        const link = "https://www.domaincabinets.com/";
        const linkWidth = doc.getTextWidth(link);
        const dateWidth = doc.getTextWidth(currentDate);

        const newPDFBlob = doc.output("blob");
        const newPdfBytes = await newPDFBlob.arrayBuffer();
        const newPdfDoc = await PDFDocument.load(newPdfBytes);
        const pages = newPdfDoc.getPages();

        const marginMM = 10;
        const footerYMM = 4;
        const mmToPt = 2.83465;

        pages.forEach((page) => {
          const pageWidthPT = page.getWidth();
          const marginPT = marginMM * mmToPt;
          const footerYPT = footerYMM * mmToPt;

          const linkWidthMM = doc.getTextWidth(link);
          const dateWidthMM = doc.getTextWidth(currentDate);
          const leftWidthMM = doc.getTextWidth("Domain Cabinets");

          const linkWidthPT = linkWidthMM * mmToPt;
          const dateWidthPT = dateWidthMM * mmToPt;
          const leftWidthPT = leftWidthMM * mmToPt;

          page.drawText("Domain Cabinets", { x: marginPT, y: footerYPT, size: 10 });
          page.drawText(link, { x: (pageWidthPT - linkWidthPT) / 2, y: footerYPT, size: 10 });
          page.drawText(currentDate, { x: pageWidthPT - marginPT - dateWidthPT, y: footerYPT, size: 10 });
        });

        const combinedPdfBytes = await newPdfDoc.save();
        const combinedPdfBlob = new Blob([combinedPdfBytes], { type: "application/pdf" });

        let htmlContent = `<h3>Your Custom Selections</h3><ul>`;

        finalArray.forEach(({ parentName, categoryName, imageName }, index) => {
          const finalImageName =
            imageName === "VerticalSequenctional"
              ? "Vertical Sequence"
              : imageName === "HorizontalSequenctional"
                ? "Horizontal Sequence"
                : imageName || "N/A";

          let itemHTML = `<li><strong>${parentName}</strong>: `;

          if (index === 0) {
            itemHTML += `${categoryName}, ${finalImageName}`;
          } else if (index >= finalArray.length - 3) {
            itemHTML += `${categoryName}: ${finalImageName}`;
          } else {
            if (parentName === "Appliance") {
              itemHTML += `${finalImageName}`;
            } else {
              itemHTML += `Door Collection: ${categoryName}`;
              itemHTML += `<br>Color: ${finalImageName}`;
            }
          }

          itemHTML += `</li>`;
          htmlContent += itemHTML;
        });

        htmlContent += `</ul><hr>`;

        sendEmailWithHTMLAndPDF(htmlContent, combinedPdfBlob, arg);
        setShowEmailPopup(false);

      } catch (err) {
        console.error("Error during PDF generation or printing:", err);
      }
    } else {
      console.error("Canvas reference is null or undefined.");
    }
  };

  const sendEmailWithHTMLAndPDF = (htmlContent, combinedPdfBlob, arg) => {
    const formData = new FormData();
    formData.append("type", arg);
    formData.append("key", layoutKey);
    formData.append("angle", layoutangle);
    formData.append("name", name);
    formData.append("email", email);
    formData.append("message", comment);
    formData.append("selected_data", htmlContent);
    formData.append("visualizer_file", combinedPdfBlob);

    ApiSendEmail("visualizer/sendenquiry", formData)
      .then(response => {
        if (arg === 'Print') {
          setIsLoading(false);
          setTimeout(() => {
            setShowEmailPopup(false);
            window.print();
          }, 2000);
        } else {
          setIsLoading(false);
        }
        if (response.Result === 1) {
          toast.success("Email sent successfully!");
        }
        setIsPopupVisible(true);
      })
      .catch(error => {
        console.error("Error sending email:", error);
        setIsLoading(false);
      });
  };

  const handleSendEmailForPrint = async (arg) => {
    setIsLoading(true);
    if (!name && !email) {
      setIsLoading(false);
      setNameError("Name is required");
      setEmailError("Email is required");
      return;
    } else if (!email) {
      setIsLoading(false);
      setEmailError("Email is required");
      return;
    } else if (!name) {
      setIsLoading(false);
      setNameError("Name is required");
      return;
    }
    generatePDF(arg);
  };

  useEffect(() => {
    const svg = document.getElementById(`${angleSvgMap[selectedAngle]}`);
    if (!svg) return;

    const regions = svg.querySelectorAll("g");
    if (!regions.length) return;

    const onMouseEnter = (e) => handleRegionHover(e.currentTarget.id);
    const onMouseLeave = () => handleRegionLeave();
    const onClick = (e) => handleRegionClick(e.currentTarget.id);

    regions.forEach((region) => {
      region.addEventListener("mouseenter", onMouseEnter);
      region.addEventListener("mouseleave", onMouseLeave);
      region.addEventListener("click", onClick);
    });

    return () => {
      regions.forEach((region) => {
        region.removeEventListener("mouseenter", onMouseEnter);
        region.removeEventListener("mouseleave", onMouseLeave);
        region.removeEventListener("click", onClick);
      });
    };
  }, [svgContent, selectedAngle]);
  useEffect(() => {
    const syncSvgSize = () => {
      const canvasArea = document.getElementById('canvas-area');
      if (!canvasArea) return;
      const svgEl = canvasArea.querySelector('svg');
      if (!svgEl) return;
      svgEl.removeAttribute('width');
      svgEl.removeAttribute('height');
      // slice mirrors object-fit:cover — SVG crops identically to the image
      svgEl.setAttribute('preserveAspectRatio', 'none');
      svgEl.style.width = '100%';
      svgEl.style.height = '100%';
      svgEl.style.display = 'block';
      svgEl.style.position = '';
      svgEl.style.top = '';
      svgEl.style.left = '';
    };

    window.addEventListener('resize', syncSvgSize);
    syncSvgSize();

    return () => window.removeEventListener('resize', syncSvgSize);
  }, [svgContent]);

  if (isMobile) {
    return (
      <div className="w-full h-screen flex items-center justify-center bg-gray-800">
        <div className="bg-white p-8 rounded-lg shadow-lg text-center max-w-md w-full">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="w-16 h-16 mx-auto mb-4 text-red-500"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlnsXlink="http://www.w3.org/1999/xlink"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M12 9v6m0 0l3-3m-3 3l-3-3m0 0h6M12 9l-3 3m0 0L9 9"
            />
          </svg>
          <h1 className="text-xl font-bold text-gray-800 mb-4">
            This website is not compatible with mobile screens
          </h1>
          <p className="text-gray-600 text-sm mb-4">
            For the best experience, please visit this tool on an iPad or Laptop.
          </p>
        </div>
      </div>
    );
  }

  return (
    <>
      {/* Outer wrapper: position:relative so Loader (absolute) is contained within the
          iframe boundary; overflow:hidden prevents content bleeding outside; dark bg
          fills any gap below the canvas image so no white space shows. */}
      <div className="relative w-full overflow-hidden print:overflow-visible">
        {isLoading && <Loader />}
        <div className="print-page">

          <div className="print:block hidden h-[50px] text-center leading-[50px] pt-[50px] pb-[40px]">
            <h2 className="text-lg font-bold items-center">Your Custom Visualizer Selections</h2>
          </div>

          <Suspense>
            <NavigationBar
              onHideGrainChange={setHideGrain}
              VisualizerCategory={VisualizerCategory}
              isLoading={isLoading}
              onImageClick={handleImageClick}
              generatePDF={generatePDF}
              selectedChildCategory={selectedChildCategory}
              setSelectedChildCategory={setSelectedChildCategory}
              defaultGrain={defaultGrain}
              setClickedData={setClickedData}
              clickedData={clickedData}
              setIsLoading={setIsLoading}
              defaultGrainType={defaultGrainType}
              hoveredCategoryId={hoveredCategoryId}
              setHoveredCategoryId={setHoveredCategoryId}
              setEmail={setEmail}
              email={email}
              setName={setName}
              name={name}
              handleEmailChange={handleEmailChange}
              handleNameChange={handleNameChange}
              handleSendEmailForPrint={handleSendEmailForPrint}
              emailError={emailError}
              nameError={nameError}
              comment={comment}
              setNameError={setNameError}
              setEmailError={setEmailError}
              setComment={setComment}
              handleCommentChange={handleCommentChange}
              setSelectedRegion={setSelectedRegion}
              showEmailPopup={showEmailPopup}
              setShowEmailPopup={setShowEmailPopup}
              setEmailOnPrint={setEmailOnPrint}
              selectedAngle={selectedAngle}
              setSelectedAngle={setSelectedAngle}
              emailOnPrint={emailOnPrint}
              setlayoutKey={setlayoutKey}
              setlayoutAngle={setlayoutAngle}
              layoutangle={layoutangle}
              layoutKey={layoutKey}
              fetchDataRef={fetchDataRef}
              categoryNames={categoryNames}
              finalArray={finalArray}
              setIsPanelOpen={setIsPanelOpen}
            />
          </Suspense>


          {/* Canvas area: fills full viewport so image never shrinks on resize.
              overflow:hidden clips any SVG bleed when aspect ratios differ. */}
          <div
            className="relative print:hidden"
            id="canvas-area"
            style={{ width: '100%', height: '100vh' }}
          >
            <canvas ref={canvasRef} id="resultCanvas" style={{ display: "none" }}></canvas>
            {/* object-fit:cover keeps the image filling the full viewport at all
                window sizes — no height shrink on resize, no gaps beside the panel. */}
            <img
              ref={resultImageRef}
              id="resultImage"
              className={(baseImage && imageUpdated) ? 'block' : 'hidden'}
              style={{ width: '100%', height: '100%' }}
              alt=""
              loading="lazy"
              src={baseImage}
            />
            {/* SVG overlay covers the same area; preserveAspectRatio slice mirrors
                object-fit:cover so clickable regions stay aligned with the image. */}
            <div className="absolute inset-0 pointer-events-auto">
              {selectedAngle && (
                <div
                  dangerouslySetInnerHTML={{ __html: svgContent }}
                  style={{ width: '100%', height: '100%', lineHeight: 0 }}
                />
              )}
            </div>

            {/* Credit line, bottom-left of the render. Distributor pages only,
                and only when that distributor's admin leaves it ticked —
                isDistributor is the half that cannot be switched off, so a plain
                /visualizer never shows it however the state is set.
                Sized in vw, not px, because that is what the reference
                screenshots show: across a 1210px-wide render and a 966px one the
                text keeps the same share of the width — 8.6% — and starts at the
                same 2.8%. The nav above it already scales that way.
                The wrapper stays click-through so it never steals a click meant
                for a cabinet region underneath; only the link is clickable.
                Plain near-black text, no shadow or halo, because the references
                have none. */}
            {isDistributor && showCredit && (
              <div className="absolute bottom-[8px] left-[2.8vw] z-10 pointer-events-none select-none">
                <a
                  href={siteURL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="pointer-events-auto text-[12px] font-light leading-none text-gray-900"
                >
                  &copy; Domain Cabinets
                </a>
              </div>
            )}
          </div>




          <PricePanel
            finalArray={finalArray}
            priceData={priceData}
            isPriceLoading={isPriceLoading}
            isPanelOpen={isPanelOpen}
            setIsPanelOpen={setIsPanelOpen}
            hideGrain={hideGrain}
            panelMode={panelMode}
            layoutLabel={VisualizerCategory?.Layout?.label || ''}
            collections={VisualizerCategory?.Collections || []}
          />


          <div className="hidden w-4/5 table-auto border-collapse w-full px-[53px] print:block pt-[10px]">
            <img
              ref={resultImagePrint}
              id=""
              className="w-full h-custom"
              alt=""
              src={baseImage}
            />
          </div>

          <div className="hidden mt-[10px] bg-white rounded-lg  print:block pl-[3.3rem]">
            <table className="w-4/5 table-auto border-collapse">
              <tbody>
                {finalArray.map((item, index) => (
                  <tr key={index}>
                    <td className="pl-12 align-top w-1/3 py-2">
                      {item.parentName}
                    </td>
                    <td className="align-top w-2/3 py-2">
                      {index === 0 ? (
                        <span>
                          {item.categoryName} ,{" "}
                          {item.imageName === "VerticalSequenctional"
                            ? "Vertical Sequence"
                            : item.imageName === "HorizontalSequenctional"
                              ? "Horizontal Sequence"
                              : item.imageName}
                        </span>
                      ) : index >= finalArray.length - 3 ? (
                        <span>{item.categoryName} : {item.imageName}</span>
                      ) : item.parentName === "Appliance" ? (
                        <span>{item.imageName || "N/A"}</span>
                      ) : (
                        <div className="leading-tight">
                          <div>Door Collection: {item.categoryName || "N/A"}</div>
                          <div>Color: {item.imageName || "N/A"}</div>
                        </div>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="hidden print:block footer-print">
            <div className="flex w-full justify-between pb-[20px]">
              <div className="text-left pl-[50px] pr-[10px]">
                <span>Domain Cabinets</span>
              </div>
              <div className="text-center">
                <span>{siteURL}</span>
              </div>
              <div className="text-right pl-[10px] pr-[50px]">
                <span>{formattedDate}</span>
              </div>
            </div>
          </div>
        </div>
      </div>{/* end outer relative wrapper */}

      <ToastContainer position="top-right" autoClose={5000} hideProgressBar newestOnTop closeButton />
    </>
  );
};

export default Home;
